import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { CalendarService } from 'src/app/Service/Calendar/Calendar.service';

@Component({
  selector: 'app-CalendarForm',
  templateUrl: './CalendarForm.component.html',
  styleUrls: ['./CalendarForm.component.scss']
})
export class CalendarFormComponent implements OnInit {

  Token:String=""

  constructor(
    private Calendar_Service:CalendarService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewCalendar=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,1124).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewCalendar:FormGroup;

  get_Form_Title(){
    return this.AddNewCalendar.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewCalendar(StartDate){

    this.InProccessing=true
    this.Calendar_Service.Add(StartDate,this.get_Form_Title().value,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The selected date already exists in the list")
        }
        else{
          this.AddNewCalendar.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



}
